import React from "react";
import { Icon } from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";

export default function Finviz(props) {
  //console.log("Favorites", props.favoritesData.stockReports);
  //alert("in snapshots");
  const sr = props.stockReports;
  const symbols = sr.map((item) => item.symbol).join(",");
  const fvlink =
    "https://finviz.com/screener.ashx?v=211&o=tickersfilter&t=" + symbols;

  return (
    <div
      id="stockchartsdiv"
      style={{
        minHeight: "74vh",
        marginBottom: "2%",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <p style={{ color: "#666", fontSize: "0.9em", marginBottom: "15px" }}>
          For technical charts you can visit{" "}
          <a
            href={fvlink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2185d0" }}
          >
            Finviz <Icon name="external alternate" size="small" />
          </a>
        </p>
      </div>
    </div>
  );
}
